module.exports = __webpack_public_path__ + "static/media/image_3.8a6f238f.jpeg";